'use strict';

const BaseModel = require('./baseModel');

class UserModel extends BaseModel {
  constructor() {
    super(userSchema);
  }

  static getSchema() {
    return userSchema;
  }
}

const userSchema = {
  email: {
    required: {
      message: 'This field is required.'
    },
    isEmail: {
      message: 'Must be a valid email.'
    }
  },
  password: {
    required: {
      message: 'This field is required.'
    },
    matches:{
      options: /^(?=.*[a-z].*)(?=.*[A-Z].*)(?=.*[0-9].*).{6,}$/,
      message: 'Must contain: One uppercase, one lowercase, one number, and be at least 6 characters.'
    }
  },
  firstName: {
    required: {
      message: 'This field is required.'
    },
    isLength: {
      options: {min: 1, max: 255},
      message: 'Max length 255 characters and Min 1 characters'
    }
  },
  lastName: {
    required: {
      message: 'This field is required.'
    },
    isLength: {
      options: {min: 1, max: 255},
      message: 'Max length 255 characters and Min 1 characters'
    }
  },
  middleName: {
    isLength: {
      options: {min: 1, max: 255},
      message: 'Max length 255 characters and Min 1 characters'
    }
  },
  nickName: {
    isLength: {
      options: {min: 1, max: 255},
      message: 'Max length 255 characters and Min 1 characters'
    }
  },
  phoneNumber: {
    required: {
      message: 'This field is required.'
    },
    isLength: {
      options: {min: 10, max: 10},
      message: 'Must be 10 digits'
    },
    isNumeric: {
      message: 'Must be numeric'
    },
    matches: {
      options: /^[2-9]\d{9}$/,
      message: 'Must be a valid phone number.'
    }
  },
  phoneExtension1 :{},
  phoneNumber1: {
    required: {
      message: 'This field is required.'
    },
    isLength: {
      options: {min: 10, max: 10},
      message: 'Must be 10 digits'
    },
    isNumeric: {
      message: 'Must be numeric'
    },
    matches: {
      options: /^[2-9]\d{9}$/,
      message: 'Must be a valid phone number.'
    }
  },
  phoneType1: {
    required: {
      message: 'This field is required.'
    }
  },
  phoneNumber2: {
    isLength: {
      options: {min: 10, max: 10},
      message: 'Must be 10 digits'
    },
    isNumeric: {
      message: 'Must be numeric'
    },
    matches: {
      options: /^[2-9]\d{9}$/,
      message: 'Must be a valid phone number.'
    }
  },
  phoneType2: {
  },
  phoneExtension2 :{},
  phoneNumber3: {
    isLength: {
      options: {min: 10, max: 10},
      message: 'Must be 10 digits'
    },
    isNumeric: {
      message: 'Must be numeric'
    },
    matches: {
      options: /^[2-9]\d{9}$/,
      message: 'Must be a valid phone number.'
    }
  },
  phoneType3: {
  },
  country: {
    required: {
      message: 'This field is required.'
    }
  },
  address: {
    required: {
      message: 'This field is required.'
    }
  },
  city: {
    required: {
      message: 'This field is required.'
    }
  },
  state: {
  },
  timezone: {
    required: {
      message: 'This field is required.'
    }
  },
  zip: {
  },
  bestContactTime: {
    required: {
      message: 'This field is required.'
    }
  },
  title: {
    required: {
      message: 'This field is required.'
    }
  },
  department: {

  },
  foundUsVia: {
    required: {
      message: 'This field is required.'
    }
  },
  foundUsOther: {
    required: {
      message: 'This field is required.'
    }
  }
};

module.exports = UserModel;



// WEBPACK FOOTER //
// ./shared/models/user.js